/* Paper Dealer — mega menu + mobile drawer behaviour (moved out of sections/pd-mega-menu.liquid, PD 2026-09).
   The desktop mount (nav → Horizon header) stays inline in the section so it happens before first paint. */
(function () {
  var wrap = document.getElementById('pd-mega-wrap');
  var nav = document.getElementById('pd-mega-nav');
  var ov = document.getElementById('pd-overlay');
  var drawer = document.getElementById('pd-mobile-drawer');
  if (!wrap || !nav) return;

  var MOBILE_BP = 1024;
  var HOVER_OPEN = 120;
  var HOVER_CLOSE = 220;
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_HOVER = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var COARSE = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  var items = Array.prototype.slice.call(nav.querySelectorAll('.pd-nav__item'));
  var triggerItems = items.filter(function (i) { return i.classList.contains('pd-nav__item--has-panel'); });
  var openTimer, closeTimer, activeId = null, lastTriggerEl = null;

  items.forEach(function (it, i) {
    var t = it.querySelector('.pd-nav__trigger');
    if (t) t.setAttribute('tabindex', i === 0 ? '0' : '-1');
  });

  function getPanel(id) { return wrap.querySelector('[data-panel-id="' + id + '"]'); }
  function getItem(id) { return nav.querySelector('[data-panel-trigger="' + id + '"]'); }

  function positionPanel(panel) {
    var headerEl = document.querySelector('header-component') || document.querySelector('.header-nav-basic');
    if (!headerEl) return;
    var rect = headerEl.getBoundingClientRect();
    panel.style.top = Math.max(0, rect.bottom) + 'px';
    // Overlay starts under the header: if it covered the header, the pointer would land on the
    // overlay, fire mouseleave on the menu item and close/re-open the panel (visible flicker).
    if (ov) ov.style.top = Math.max(0, rect.bottom) + 'px';
  }

  function openPanel(id) {
    clearTimeout(closeTimer);
    if (activeId && activeId !== id) closePanel(activeId, true);
    var panel = getPanel(id), item = getItem(id);
    if (!panel) return;
    positionPanel(panel);
    panel.removeAttribute('hidden');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    if (item) {
      item.classList.add('is-open');
      var trig = item.querySelector('.pd-nav__trigger');
      if (trig) trig.setAttribute('aria-expanded', 'true');
    }
    if (ov) ov.classList.add('is-visible');
    activeId = id;
  }

  function closePanel(id, fast) {
    var panel = getPanel(id), item = getItem(id);
    if (panel) {
      panel.classList.remove('is-open');
      var hide = function () { if (!panel.classList.contains('is-open')) panel.setAttribute('hidden', ''); };
      if (fast || REDUCED_MOTION) hide(); else setTimeout(hide, 280);
    }
    if (item) {
      item.classList.remove('is-open');
      var trig = item.querySelector('.pd-nav__trigger');
      if (trig) trig.setAttribute('aria-expanded', 'false');
    }
    if (ov) ov.classList.remove('is-visible');
    if (activeId === id) activeId = null;
  }

  function closeAll() { if (activeId) closePanel(activeId); }

  // Hover via Pointer Events, not gated on the (hover: hover) media query: touch-screen laptops,
  // pens and some embedded previews report hover:none even when a mouse is in use.
  triggerItems.forEach(function (item) {
    var id = item.getAttribute('data-panel-trigger');
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(id); }, HOVER_OPEN);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { closePanel(id); }, HOVER_CLOSE);
    });
    var panel = getPanel(id);
    if (panel) {
      panel.addEventListener('pointerenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('pointerleave', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
        closeTimer = setTimeout(function () { closePanel(id); }, HOVER_CLOSE);
      });
    }
  });

  triggerItems.forEach(function (item) {
    var id = item.getAttribute('data-panel-trigger');
    var trigger = item.querySelector('.pd-nav__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      // First click/tap opens the panel if hover has not already done so; a click on an open trigger follows its link.
      if (activeId !== id) {
        e.preventDefault();
        openPanel(id);
        lastTriggerEl = trigger;
      }
    });
  });

  function focusItem(idx) {
    if (idx < 0) idx = items.length - 1;
    if (idx >= items.length) idx = 0;
    items.forEach(function (it, i) {
      var t = it.querySelector('.pd-nav__trigger');
      if (t) t.setAttribute('tabindex', i === idx ? '0' : '-1');
    });
    var t = items[idx].querySelector('.pd-nav__trigger');
    if (t) t.focus();
  }

  items.forEach(function (item, idx) {
    var trigger = item.querySelector('.pd-nav__trigger');
    if (!trigger) return;
    trigger.addEventListener('keydown', function (e) {
      var id = item.getAttribute('data-panel-trigger');
      switch (e.key) {
        case 'ArrowRight': e.preventDefault(); focusItem(idx + 1); break;
        case 'ArrowLeft':  e.preventDefault(); focusItem(idx - 1); break;
        case 'Home':       e.preventDefault(); focusItem(0); break;
        case 'End':        e.preventDefault(); focusItem(items.length - 1); break;
        case 'ArrowDown':
        case 'Enter':
        case ' ':
          if (item.classList.contains('pd-nav__item--has-panel')) {
            e.preventDefault();
            if (activeId === id) {
              closePanel(id);
              trigger.focus();
            } else {
              openPanel(id);
              lastTriggerEl = trigger;
              var panel = getPanel(id);
              if (panel) {
                var first = panel.querySelector('a, button');
                if (first) first.focus();
              }
            }
          }
          break;
        case 'Escape':
          if (activeId === id) {
            e.preventDefault();
            closePanel(id);
            trigger.focus();
          }
          break;
      }
    });
  });

  if (ov) ov.addEventListener('click', closeAll);
  document.addEventListener('click', function (e) {
    if (activeId && !wrap.contains(e.target) && !nav.contains(e.target)) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeId) {
      var t = lastTriggerEl;
      closeAll();
      if (t) t.focus();
    }
  });

  var rePos = function () {
    if (!activeId) return;
    var p = getPanel(activeId);
    if (p) positionPanel(p);
  };
  window.addEventListener('scroll', rePos, { passive: true });
  var pw = document.querySelector('.page-wrapper');
  if (pw) pw.addEventListener('scroll', rePos, { passive: true });
  window.addEventListener('resize', rePos);

  // Mobile drawer
  if (!drawer) return;
  var lastDrawerTrigger = null, scrollY = 0;

  // iOS detection — iOS Safari has known transform stacking bugs
  var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
               (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (IS_IOS) {
    drawer.classList.add('pd-ios');
    if (window.PD_DEBUG) console.log('[PD drawer] iOS detected, using display-based level switching');
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    var closeBtn = drawer.querySelector('.pd-mobile-drawer__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }
  // Horizon's hamburger is <details><summary>: if its own state ever flips to open,
  // the icon stays an "X". Always reset it so the hamburger shows again.
  function resetHorizonDrawer() {
    document.querySelectorAll('header-drawer').forEach(function (hd) {
      try { if (hd.isOpen && typeof hd.close === 'function') hd.close(); } catch (e) {}
      hd.querySelectorAll('details[open]').forEach(function (d) { d.classList.remove('menu-open'); d.removeAttribute('open'); });
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    drawer.querySelectorAll('.pd-mobile-drawer__level').forEach(function (l) {
      l.classList.remove('pd-mobile-drawer__level--active');
    });
    var root = drawer.querySelector('[data-level="0"]');
    if (root) root.classList.add('pd-mobile-drawer__level--active');
    resetHorizonDrawer();
    if (lastDrawerTrigger) {
      try { lastDrawerTrigger.focus(); } catch (e) {}
    }
  }

  drawer.querySelectorAll('[data-pd-drawer-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  // window + capture runs before Horizon's delegated on:click (document), so Horizon's own drawer never toggles.
  window.addEventListener('click', function (e) {
    if (window.innerWidth > MOBILE_BP) return;
    var hit = e.target.closest('[data-mobile-menu], .mobileMenu-toggle, .header__icon--menu');
    if (hit) {
      e.preventDefault();
      e.stopImmediatePropagation();
      lastDrawerTrigger = hit;
      openDrawer();
      setTimeout(resetHorizonDrawer, 0);
    }
  }, true);

  var levelSwitchLock = false;
  var lastClickTime = 0;
  var lastClickTarget = null;

  drawer.querySelectorAll('[data-open-level]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // CAPTURE target IMMEDIATELY - before any async operations
      var target = b.getAttribute('data-open-level');
      var now = Date.now();

      // Filter 1: Reject events fired ≤100ms apart with same target (touch+click duplicate)
      if (target === lastClickTarget && (now - lastClickTime) < 100) {
        if (window.PD_DEBUG) console.log('[PD drawer] duplicate event filtered. target=', target);
        return;
      }
      lastClickTarget = target;
      lastClickTime = now;

      // Filter 2: Hard lock (350ms) - prevents rapid switching across different targets
      if (levelSwitchLock) {
        if (window.PD_DEBUG) console.log('[PD drawer] level switch locked, ignoring. target=', target);
        return;
      }
      levelSwitchLock = true;
      setTimeout(function () { levelSwitchLock = false; }, 350);

      var next = drawer.querySelector('.pd-mobile-drawer__level[data-level="' + target + '"]');
      if (window.PD_DEBUG) console.log('[PD drawer] open-level click. target=', target, 'next=', next);
      if (!next) {
        if (window.PD_DEBUG) console.warn('[PD drawer] No level found for target', target);
        return;
      }

      // Aggressive: explicitly REMOVE active from ALL levels (named loop, not arrow)
      var allLevels = drawer.querySelectorAll('.pd-mobile-drawer__level');
      for (var i = 0; i < allLevels.length; i++) {
        allLevels[i].classList.remove('pd-mobile-drawer__level--active');
      }

      // Force browser to flush class changes
      void next.offsetWidth;

      // Apply active to ONLY the captured target
      next.classList.add('pd-mobile-drawer__level--active');
      if (window.PD_DEBUG) console.log('[PD drawer] active level is now', next.getAttribute('data-level'));

      // Triple self-correction check at 50ms, 200ms, 500ms
      function selfCorrect(label) {
        var actives = drawer.querySelectorAll('.pd-mobile-drawer__level--active');
        if (actives.length > 1) {
          if (window.PD_DEBUG) console.warn('[PD drawer] ' + label + ': Multiple active levels detected, re-correcting');
          for (var j = 0; j < actives.length; j++) {
            if (actives[j] !== next) actives[j].classList.remove('pd-mobile-drawer__level--active');
          }
        } else if (actives.length === 1 && actives[0] !== next) {
          if (window.PD_DEBUG) console.warn('[PD drawer] ' + label + ': Wrong active level, correcting');
          actives[0].classList.remove('pd-mobile-drawer__level--active');
          next.classList.add('pd-mobile-drawer__level--active');
        } else if (actives.length === 0) {
          if (window.PD_DEBUG) console.warn('[PD drawer] ' + label + ': No active level, re-applying');
          next.classList.add('pd-mobile-drawer__level--active');
        }
      }
      setTimeout(function () { selfCorrect('50ms check'); }, 50);
      setTimeout(function () { selfCorrect('200ms check'); }, 200);
      setTimeout(function () {
        selfCorrect('500ms final');
        var first = next.querySelector('.pd-mobile-drawer__back') || next.querySelector('a, button');
        if (first) first.focus();
      }, 500);
    });
  });

  drawer.querySelectorAll('[data-back-level]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var root = drawer.querySelector('.pd-mobile-drawer__level[data-level="0"]');
      if (!root) return;
      // Defensive: clear --active from ALL levels first
      drawer.querySelectorAll('.pd-mobile-drawer__level').forEach(function (l) {
        l.classList.remove('pd-mobile-drawer__level--active');
      });
      root.classList.add('pd-mobile-drawer__level--active');
      if (window.PD_DEBUG) console.log('[PD drawer] back to root');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
